import { Component, OnInit } from '@angular/core';
import { Constants } from '../constants/constants';
import { MatDialogRef } from '@angular/material/dialog';
import { GlobalAppData } from '../models/global-app-data';

@Component({
  selector: 'app-paybybank-learn-more',
  templateUrl: './paybybank-learn-more.component.html',
  styleUrl: './paybybank-learn-more.component.css',
  standalone: false,
})
export class PaybybankLearnMoreComponent implements OnInit {
  
  oscCodes: Array<any> = Constants.OSC_SYSTEM_CODES;
  
  constructor(public dialogRef: MatDialogRef<PaybybankLearnMoreComponent>,public gdSession:GlobalAppData){
    dialogRef.disableClose = true;
  }


  ngOnInit(): void {
  }
  
  exit() {
    this.dialogRef.close();
  }
}
